import { render, staticRenderFns } from "./LayoutBreadcrumbs.vue?vue&type=template&id=22928b88&scoped=true&"
import script from "./LayoutBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./LayoutBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutBreadcrumbs.vue?vue&type=style&index=0&id=22928b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22928b88",
  null
  
)

export default component.exports